 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		45: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~CurationUploaderAdd~FacebookAdPreferences~SquarePreferences~SquarespacePreferences~Uploader-~980a85e9","1":"vendors~pages-account~pages-admin-redirects~pages-auth-Login~pages-auth-SignUp~pages-auth-VerifyTwoF~20fabb97","2":"vendors~FacebookAdPreferences~SquarePreferences~SquarespacePreferences~activity~fileOverlay-FileOver~280d8f46","3":"vendors~CurationUploaderAdd~CurationUploaderEdit~NationBuilderPreferencesPage~Uploader-DesignUploade~115101c3","4":"vendors~CurationUploaderAdd~CurationUploaderEdit~Uploader-DesignUploaderOverlayAdd~Uploader-DesignUp~ee48f668","5":"vendors~activity~components-YourLevelPage~fileOverlay-FileOverlay~files~pages-auth-VerifyTwoFactor-V~403f6b55","6":"vendors~CurationUploaderAdd~Uploader-DesignUploaderOverlayAdd~activity~components-ProfilePage~files~~5658d979","7":"FacebookAdPreferences~NationBuilderPreferencesPage~PreziPreferences~SquarePreferences~SquarespacePreferences","8":"vendors~components-LogInMethodPage~components-PersonalInformationPage~components-ProfessionalBackgro~35dff39e","9":"vendors~components-LogInMethodPage~components-PersonalInformationPage~components-ProfessionalBackgro~6457156e","10":"pages-account~pages-projects-ProjectsApp~pages-your-work-YourWorkApp","11":"pages-auth-Login~pages-auth-SignUp~pages-auth-VerifyTwoFactor-VerifyLogin","12":"vendors~components-PortfolioPage~components-ProfessionalBackgroundPage~payments","13":"CurationUploaderEdit~Uploader-DesignUploaderOverlayEdit","14":"FacebookAdPreferences~SquarePreferences","15":"PasswordStrengthBar","16":"components-PersonalInformationPage~components-ProfessionalBackgroundPage","17":"pages-account~pages-getting-started","18":"vendors~99designs-frontend-components-apps-global-nav-components-GlobalNavDrawers-GlobalNavDrawers~p~bd95d979","19":"vendors~CurationUploaderEdit~Uploader-DesignUploaderOverlayEdit","20":"vendors~PasswordStrengthBar","21":"99designs-frontend-components-apps-global-nav-components-GlobalNavDrawers-GlobalNavDrawers","22":"CurationUploaderAdd","23":"CurationUploaderEdit","24":"FacebookAdPreferences","25":"NationBuilderPreferencesPage","26":"PreziPreferences","27":"SquarePreferences","28":"SquarespacePreferences","29":"Uploader-DesignUploaderOverlayAdd","30":"Uploader-DesignUploaderOverlayEdit","31":"activity","32":"components-CurationSamplesPage-CurationSamplesPage","33":"components-LogInMethodPage","34":"components-NotificationsPage","35":"components-PersonalInformationPage","36":"components-PortfolioPage","37":"components-ProfessionalBackgroundPage","38":"components-ProfilePage","39":"components-TermsPage","40":"components-VerificationPage","41":"components-YourLevelPage","42":"design-transfer-agreement","43":"fileOverlay-FileOverlay","44":"files","46":"overview","47":"pages-account","48":"pages-admin-redirects","49":"pages-auth-Login","50":"pages-auth-SignUp","51":"pages-auth-VerifyTwoFactor-VerifyAddPayout","52":"pages-auth-VerifyTwoFactor-VerifyLogin","53":"pages-create","54":"pages-designer-onboarding-DesignerOnboarderPage","55":"pages-getting-started","56":"pages-handover-messages","57":"pages-messages","58":"pages-notifications","59":"pages-projects-ProjectsApp","60":"pages-projects-cancel-invites","61":"pages-status","62":"pages-web-get-started-WebOnboarderPage","63":"pages-your-work-YourWorkApp","64":"payments","66":"vendors~PreziPreferences","67":"vendors~SquarespacePreferences","68":"vendors~components-PortfolioPage","69":"vendors~fileOverlay-FileOverlay","70":"vendors~pages-admin-redirects","71":"vendors~pages-designer-onboarding-DesignerOnboarderPage","72":"vendors~pages-projects-ProjectsApp","73":"vendors~pages-your-work-YourWorkApp","74":"vendors~payments"}[chunkId]||chunkId) + "." + {"0":"485e1dda85","1":"d037664ba2","2":"75eb733616","3":"cfb3dd0736","4":"5544af6c18","5":"3c4939b772","6":"3f103141df","7":"4fe54d2b35","8":"4704e1932b","9":"e3a7024f6c","10":"45dabecaec","11":"577aaff9a4","12":"a2630c7623","13":"994fa63269","14":"8b2ecaecc3","15":"007d943321","16":"b147ccbcc8","17":"d330e9d7b1","18":"d490641e71","19":"d109545cfd","20":"c7686321dc","21":"2d0202a4c1","22":"5e5c112f4d","23":"e8a0bd909a","24":"85faa14373","25":"3c31169f07","26":"777a3fdbec","27":"598fede716","28":"7b507fe8b2","29":"eeaf4efdf8","30":"4491ee9994","31":"16338c0ed0","32":"b271be4650","33":"165e086dc2","34":"5411191d09","35":"12a10c3dd7","36":"5a5d335198","37":"0487e6878e","38":"5ecdb8ec1f","39":"430b7878dc","40":"7c7a796bfc","41":"dae4d2b61a","42":"a5b7650774","43":"4ba17ae3f5","44":"77ee3a08d9","46":"4e0c9434e3","47":"fba6f048ee","48":"02dda9b288","49":"62ac0cc98f","50":"4cac4aed75","51":"d3050ac536","52":"a08f0987a6","53":"d15d1f52ed","54":"61e57a15b0","55":"c8906b64a9","56":"e2cbd0c51b","57":"1cce52cb8a","58":"193ea8d6a7","59":"5df1c6bf76","60":"815f6a24ae","61":"6a7d33ac8c","62":"c2fc4c88f9","63":"ccbd032d0a","64":"4cc033ae57","66":"e15966b4e4","67":"a415534816","68":"0bc0056b0d","69":"8977e91387","70":"41a4ca2372","71":"8c8cefd2f2","72":"977d4b984f","73":"20d70cf918","74":"52f43832ad","75":"9ca5861e1e","76":"5830cbcd72","77":"f12367ece0","78":"c9fdc67291"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/en/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 301);
